<div class="flex flex-col gap-2" [formGroup]="formGroup">
  <lib-perio-number-selector
    formControlName="mob"
    variant="orange"
    measurementType="mobility"
    [reversed]="reversed()"
  ></lib-perio-number-selector>
  <lib-perio-number-selector
    formControlName="fg"
    variant="blue"
    numberDisplayType="roman"
    measurementType="furcuation"
    [disabled]="fgDisabled()"
    [reversed]="reversed()"
  ></lib-perio-number-selector>
</div>
